import { AppUrls } from '../../../../../../../common/dto/app-urls';
import { Route } from '@angular/router';

export const KnowledgeBaseEditorRoutes: Route = {
  path: AppUrls.Dashboard._.Help._.KnowledgeBase._.KnowledgeBaseEditor.relativeUrl,
  loadComponent: () => import('./knowledge-base-editor.component').then(_ => _.KnowledgeBaseEditorComponent),
  children: [
    {
      path: AppUrls.Dashboard._.Help._.KnowledgeBase._.KnowledgeBaseEditor._.General.relativeUrl,
      loadComponent: () => import('./knowledge-base-editor-general/knowledge-base-editor-general.component').then(_ => _.KnowledgeBaseEditorGeneralComponent),
      pathMatch: 'full'
    },
    {
      path: AppUrls.Dashboard._.Help._.KnowledgeBase._.KnowledgeBaseEditor._.Categories.relativeUrl,
      loadComponent: () => import('./knowledge-base-editor-categories/knowledge-base-editor-categories.component').then(_ => _.KnowledgeBaseEditorCategoriesComponent),
    },
    {
      path: AppUrls.Dashboard._.Help._.KnowledgeBase._.KnowledgeBaseEditor._.Featured.relativeUrl,
      loadComponent: () => import('./knowledge-base-editor-featured/knowledge-base-editor-featured.component').then(_ => _.KnowledgeBaseEditorFeaturedComponent),
    },
    {
      path: AppUrls.Dashboard._.Help._.KnowledgeBase._.KnowledgeBaseEditor._.Domains.relativeUrl,
      loadComponent: () => import('./knowledge-base-editor-domains/knowledge-base-editor-domains.component').then(_ => _.KnowledgeBaseEditorDomainsComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Help._.KnowledgeBase._.KnowledgeBaseEditor._.General.relativeUrl,
    },
  ],
};
